import React from 'react';
import { FooterContainer, Content, Div, LogoContainer, Point, Copyright } from './styles';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <Content>
        <Div>
          <LogoContainer>WALLJOBS</LogoContainer>
          <Point>●</Point>
          <Copyright>Copyright © {currentYear} WallJobs. All rights reserved.</Copyright>
        </Div>
      </Content>
    </FooterContainer>
  );
};

export default Footer;